var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[(_vm.$route.meta.authenticated)?_c('a',{staticClass:"small",on:{"click":_vm.logout}},[_vm._v(" Logout ")]):_vm._e(),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"muted small",attrs:{"href":"https://nozem.space","target":"_blank"}},[_vm._v(" Made by "),_c('strong',[_vm._v("Nozem")])])
}]

export { render, staticRenderFns }